@use './config' as config;

:host {
  position: fixed;
  z-index: 200;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0.5em calc(env(safe-area-inset-right, 0) + 0.5em) calc(env(safe-area-inset-bottom, 0) + 0.5em)
    calc(env(safe-area-inset-left, 0) + 0.5em);
  background-color: config.$footnote-bg-color;
}

:host(.footnote-static) {
  display: block;
  // for position static z-index is not working, causing issues when the angular component bottom-button-bar is used on the page
  position: relative;
  // make sure, that altered offset of sticky footnote does not affect static footnote
  right: unset;
  bottom: unset;
  left: unset;
}
